import React from 'react';
import { SEOHead } from '../components/SEOHead';
import { Link } from 'react-router-dom';
import { Badge } from '../components/ui/badge';
import { COMPANY_INFO } from '../lib/utils';

export default function CookiesPage() {
  return (
    <div>
      <SEOHead title="Gestion des cookies" description="Information sur les cookies utilisés par Ptitservices.com et vos choix." path="/cookies" />
      <section className="bg-[linear-gradient(135deg,hsla(195,20%,97%,1)_0%,hsla(182,40%,94%,1)_55%,hsla(195,20%,97%,1)_100%)] py-12 sm:py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <div className="flex items-center gap-2 text-sm text-muted-foreground mb-6">
            <Link to="/" className="hover:text-foreground">Accueil</Link>
            <span>/</span>
            <span className="text-foreground font-medium">Politique de cookies</span>
          </div>
          <Badge className="mb-3 bg-[hsl(var(--brand-mint))] text-[hsl(var(--brand-ink))] hover:bg-[hsl(var(--brand-mint))]">Cookies</Badge>
          <h1 className="font-['Space_Grotesk'] text-3xl sm:text-4xl font-semibold tracking-tight">Politique de cookies</h1>
        </div>
      </section>

      <section className="py-12 sm:py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <div className="space-y-8">
            <div>
              <h2 className="font-['Space_Grotesk'] text-xl font-semibold mb-3">1. Qu'est-ce qu'un cookie ?</h2>
              <div className="text-sm text-muted-foreground leading-relaxed">
                <p>Un cookie est un petit fichier texte déposé sur votre terminal (ordinateur, tablette, smartphone) lors de votre visite sur un site internet. Il permet au site de mémoriser des informations relatives à votre navigation (pages visitées, préférences, etc.).</p>
              </div>
            </div>

            <div>
              <h2 className="font-['Space_Grotesk'] text-xl font-semibold mb-3">2. Cookies utilisés sur ce site</h2>
              <div className="text-sm text-muted-foreground leading-relaxed space-y-3">
                <div className="p-4 rounded-lg bg-[hsl(var(--secondary))]/60">
                  <h3 className="font-semibold text-foreground mb-1">Cookies strictement nécessaires</h3>
                  <p>Ces cookies sont indispensables au bon fonctionnement du site. Ils ne peuvent pas être désactivés.</p>
                  <ul className="list-disc pl-5 mt-2 space-y-1">
                    <li><strong>cookie_consent</strong> : mémorise votre choix concernant les cookies (durée : 12 mois)</li>
                  </ul>
                </div>

                <div className="p-4 rounded-lg bg-[hsl(var(--secondary))]/60">
                  <h3 className="font-semibold text-foreground mb-1">Cookies analytiques (optionnels)</h3>
                  <p>Ces cookies nous permettent de mesurer l'audience du site et d'améliorer son contenu. Ils ne sont déposés qu'avec votre consentement.</p>
                  <p className="mt-1 italic">Actuellement, aucun cookie analytique n'est utilisé sur ce site.</p>
                </div>

                <div className="p-4 rounded-lg bg-[hsl(var(--secondary))]/60">
                  <h3 className="font-semibold text-foreground mb-1">Cookies publicitaires</h3>
                  <p>Aucun cookie publicitaire n'est utilisé sur ce site.</p>
                </div>
              </div>
            </div>

            <div>
              <h2 className="font-['Space_Grotesk'] text-xl font-semibold mb-3">3. Gestion de vos préférences</h2>
              <div className="text-sm text-muted-foreground leading-relaxed space-y-2">
                <p>Lors de votre première visite sur le site, un bandeau de consentement vous permet d'accepter ou de refuser les cookies non essentiels.</p>
                <p>Vous pouvez également gérer vos préférences à tout moment depuis les paramètres de votre navigateur :</p>
                <ul className="list-disc pl-5 space-y-1">
                  <li><strong>Chrome :</strong> Paramètres &gt; Confidentialité et sécurité &gt; Cookies</li>
                  <li><strong>Firefox :</strong> Paramètres &gt; Vie privée et sécurité &gt; Cookies</li>
                  <li><strong>Safari :</strong> Préférences &gt; Confidentialité &gt; Cookies</li>
                  <li><strong>Edge :</strong> Paramètres &gt; Cookies et autorisations de site</li>
                </ul>
                <p className="mt-2">La désactivation des cookies strictement nécessaires peut altérer le fonctionnement du site.</p>
              </div>
            </div>

            <div>
              <h2 className="font-['Space_Grotesk'] text-xl font-semibold mb-3">4. Durée de conservation des cookies</h2>
              <div className="text-sm text-muted-foreground leading-relaxed">
                <p>Les cookies de consentement sont conservés pendant une durée maximale de 12 mois. Au-delà, votre consentement vous sera demandé à nouveau.</p>
              </div>
            </div>

            <div>
              <h2 className="font-['Space_Grotesk'] text-xl font-semibold mb-3">5. En savoir plus</h2>
              <div className="text-sm text-muted-foreground leading-relaxed space-y-2">
                <p>Pour en savoir plus sur les cookies et vos droits, vous pouvez consulter :</p>
                <ul className="list-disc pl-5 space-y-1">
                  <li>Le site de la CNIL : <a href="https://www.cnil.fr/fr/cookies-et-autres-traceurs" target="_blank" rel="noopener noreferrer" className="text-[hsl(var(--primary))] underline">www.cnil.fr</a></li>
                  <li>Notre <Link to="/politique-confidentialite" className="text-[hsl(var(--primary))] underline">politique de confidentialité</Link></li>
                </ul>
                <p>Pour toute question, contactez-nous : <a href={`mailto:${COMPANY_INFO.email}`} className="text-[hsl(var(--primary))] underline">{COMPANY_INFO.email}</a></p>
              </div>
            </div>

            <div className="pt-4 border-t border-border">
              <p className="text-xs text-muted-foreground">Dernière mise à jour : Janvier 2025</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
